module.exports = __webpack_public_path__ + "img/ss_ye-01.151b4129.jpg";